import { TIMER_CHANNEL } from '@app/constants/timers/timers'
import { closeChannel, openChannel } from '@app/actions/timers/timers'
import openCable from '../cable'

const timerChannel = ({ request, response }) => {
  const cable = openCable()
  const subscription = cable.subscriptions.consumer.subscriptions.subscriptions.find(
    (sub) => sub.identifier.includes(TIMER_CHANNEL),
  )
  if (!subscription) {
    return cable.subscriptions.create(TIMER_CHANNEL, {
      connected() {
        request(this)
        store.dispatch(openChannel())
      },
      received(data) {
        response(data)
      },
      disconnected: () => {
        store.dispatch(closeChannel())
      },
    })
  }
  return subscription
}

export default {
  timerChannel,
}
